import React from 'react';
import AppStoreButtons from './AppStoreButtons';
import PopularVideos from '../Video/PopularVideos';
import { MyRecentVideos} from '../History';

const FeaturesSection = ({
  // User authentication
  isLoggedIn,
  userId,
  setLoginDialogOpen,
  // History data
  history,
  // Feature blocking
  checkAndExecute
}) => {
  return (
    <>
      <AppStoreButtons />
      
      <PopularVideos 
        isLoggedIn={isLoggedIn}
        userId={userId}
        setLoginDialogOpen={setLoginDialogOpen}
        checkAndExecute={checkAndExecute}
      />
      
      <MyRecentVideos 
        isLoggedIn={isLoggedIn}
        userId={userId}
        history={history}
        checkAndExecute={checkAndExecute}
      />
    </>
  );
};

export default FeaturesSection; 